import React from 'react'
import {GetMyOrderPreferencesQuery} from '@data/__generated__/types.main'
import {getWebsiteMenuInformation_cached_website} from '@data/queries/website/__generated__/getWebsiteMenuInformation_cached'
import hasWebpSupport from '@helpers/misc/hasWebpSupport'
import useWebsiteId from '@hooks/useWebsiteId'

import {getCategoriesAndProductsCPGsWeb_cached_categories} from './__generated__/getCategoriesAndProductsCPGsWeb_cached'
import {getCategoriesAndProductsWeb_cached_categories} from './__generated__/getCategoriesAndProductsWeb_cached'
import ProductsContent from './ProductsContent'
import useCategoriesAndProducts from './useCategoriesAndProducts'

const ProductsContentMemo = React.memo(ProductsContent)

export interface ProductsProps {
  menuId: string
  storeId: string
  deliverAt: string
  productsLayout: string
  layout: any
  loading?: boolean
  nextOpenDate: JSX.Element
  preferences: GetMyOrderPreferencesQuery['preferences']
  productCardDesign: string
  website: getWebsiteMenuInformation_cached_website

  /**
   * If included, will use to prerender on serverside. Note: These queries are big, and are currently causing performance issues for sites with a lot of products.
   * We disabled them temporarily (by removing it from props in pages/order/index).
   */
  preloadedCategories?:
    | getCategoriesAndProductsWeb_cached_categories
    | getCategoriesAndProductsCPGsWeb_cached_categories
}

export default function Products(props: ProductsProps) {
  const {menuId, storeId, deliverAt, preloadedCategories, website} = props
  const websiteId = useWebsiteId()
  const format = hasWebpSupport() ? 'webp' : 'jpeg'
  const {categories} = useCategoriesAndProducts({
    websiteId,
    menuId,
    format,
    preloadedCategories,
    storeId,
    deliverAt
  })

  return <ProductsContentMemo {...props} website={website} categories={categories} />
}
